import * as React from 'react';
import { FieldArray } from 'formik';
import { Input } from 'src/components/Shared/BsInput';
import ContentsAutocomplete from 'src/containers/Shared/ContentsAutocomplete';

export default class Contents extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.renderSelected = this.renderSelected.bind(this);
  }

  public render() {
    const { values, handleChange } = this.props;
    return (
      <div>
        <div className="form-group">
          <label>Columnas</label>
          <select
            name="data.columns"
            className="form-control"
            onChange={handleChange}
            value={values.data.columns}
          >
            <option value=""></option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
          </select>
        </div>
        <div className="form-group">
          <label>Tipo</label>
          <select
            name="data.type"
            className="form-control"
            onChange={handleChange}
            value={values.data.type}
          >
            <option value=""></option>
            <option value="simple">Simple (Imagen y texto)</option>
            <option value="image">Solo Imagen</option>
            <option value="slide">Slide</option>
          </select>
        </div>
        <FieldArray
          name="data.contents"
          render={(arrayHelpers) => {
            return (
              <div>
                <div className="form-group">
                  <label>Buscar contenido</label>
                  <ContentsAutocomplete
                    onSelected={(selected: any) => {
                      if (!selected) {
                        return;
                      }

                      arrayHelpers.push({
                        ...selected,
                        order: values.data.contents.length + 1,
                      });
                    }}
                  />
                </div>
                {
                  values.data.contents.map((d: any, i: number) =>
                    this.renderSelected(d, i, arrayHelpers)
                  )
                }
              </div>
            );
          }}
        />
      </div>
    )
  }

  private renderSelected(content: any, index: number, arrayHelpers: any) {
    return (
      <div className="card mb-3" key={index}>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <Input
                label="Orden"
                value={content.order}
                name={`data.contents.${index}.order`}
                onChange={this.props.handleChange}
                errors={this.props.errors}
                type="number"
              />
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>ID</label>
                <input
                  type="text"
                  readOnly
                  className="form-control"
                  value={content.id}
                />
              </div>
            </div>
            <div className="col-md-5">
              <div className="form-group">
                <label>Titulo</label>
                <input
                  type="text"
                  readOnly
                  className="form-control"
                  value={content.title}
                />
              </div>
            </div>
            <div className="col-md-5">
              <div className="form-group">
                <label>Slug</label>
                <input
                  type="text"
                  readOnly
                  className="form-control"
                  value={content.slug}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="text-right">
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={(e) => {
                e.preventDefault();
                arrayHelpers.remove(index);
              }}
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>

    );
  };
}



// WEBPACK FOOTER //
// ./src/containers/Module/Types/Contents.tsx